/* eslint-disable */
// 接入Slardar和Sentry

// 判断是否为ppe环境
const isPPE = window.GLOBAL_VAR && window.GLOBAL_VAR.template_config_key && window.GLOBAL_VAR.template_config_key.indexOf('ppe') > -1
// 判断是否为开发或测试环境
const isDEVorTest = ['development', 'test', 'abtest'].indexOf(CONF_ENV) > -1
// 格式化组件名称
function formatComponentName (vm) {
  if (vm.$root === vm) {
    return 'root instance'
  }
  const name = vm._isVue ? vm.$options.name || vm.$options._componentTag : vm.name
  return (
    (name ? 'component <' + name + '>' : 'anonymous component') +
    (vm._isVue && vm.$options.__file ? ' at ' + vm.$options.__file : '')
  )
}

// dev && test && abtest && ppe 环境不进行信息上报
// if (!(isPPE || isDEVorTest) && !window.Slardar) {
//   (function (i, s, o, g, r, a, m) {
//     i['SlardarMonitorObject'] = r
//     i[r] = i[r] || function () { (i[r].q = i[r].q || []).push(arguments) }
//     i[r].l = 1 * new Date()
//     a = s.createElement(o)
//     m = s.getElementsByTagName(o)[0]
//     a.async = 1
//     a.src = g
//     m.parentNode.insertBefore(a, m)
//     console.log('slardar loaded')
//   })(window, document, 'script', 'https://i.snssdk.com/slardar/sdk.js?bid=ad_fe_platform_web', 'Slardar')

//   const slardarWebId = (window.GLOBAL_VAR && window.GLOBAL_VAR.advertiser && window.GLOBAL_VAR.advertiser.id) || ''
//   const adminName = (window.GLOBAL_VAR && window.GLOBAL_VAR.coreUser && window.GLOBAL_VAR.coreUser.adminName) || ''
//   const id = (window.GLOBAL_VAR && window.GLOBAL_VAR.coreUser && window.GLOBAL_VAR.coreUser.id) || ''
//   window.Slardar && window.Slardar('config', {
//     sampleRate: 1,
//     bid: 'ad_fe_platform_web',
//     pid: window.location.pathname.replace(/[/.]/g, '_'),
//     ignoreAjax: ['mcs.snssdk.com', 'api.growingio.com', '//lf3-config.bytetcc.com/obj/tcc-config-web/'],
//     ignoreStatic: ['default/layer.css'],
//     hookFetch: true,
//     enableSizeStats: true,
//     domain: 'i.snssdk.com', // 注意上报域名如果使用默认域名 i.snssdk.com, 可不填写。 如果是国际化项目，请改成 mon-va.byteoversea.com
//     slardar_web_id: slardarWebId,
//     context: {
//       adminName,
//       id,
//       locale: $.cookie('locale') || 'zh'
//     },
//     plugins: {
//       sentry: {
//         beforeSend (event, hint) {
//           // 过滤无效错误
//           if (event.message && event.message.startsWith('Non-Error exception captured')) {
//             if (hint && hint.originalException && hint.originalException.error) {
//               window.Slardar('Sentry', function (Sentry) {
//                 Sentry.withScope && Sentry.withScope(function (scope) {
//                   scope.setExtra('nonErrorException', true)
//                   Sentry.captureException(hint.originalException.error)
//                 })
//               })
//             }
//             return null
//           }
//           return event
//         }
//       }
//     }
//   })
//   // 处理vue全局报错函数
//   Vue.config.errorHandler = function (error, vm, info) {
//   // 打印错误在控制台
//     console.error(error)

//     const metaData = {}

//     // vm and lifecycleHook are not always available
//     if (Object.prototype.toString.call(vm) === '[object Object]') {
//       metaData.componentName = formatComponentName(vm)
//       metaData.propsData = vm.$options.propsData
//     }
//     if (typeof info !== 'undefined') {
//       metaData.lifecycleHook = info
//     }

//     window.Slardar && window.Slardar('Sentry', function (Sentry) {
//       Sentry.captureException(error, {
//         extra: {
//           components: vm.name,
//           info: info
//         }
//       })
//     })
//   }
//   // 发送pv
//   window.Slardar('send', 'pageview')
// }
